(() => {
  const escapeRegExp = (value) => value.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const boot = (config) => {
    const scope = document.querySelector(config.dataset.scope);
    if (!scope) return;

    let messages = {};
    try {
      const mapParts = Object.entries(config.dataset)
        .filter(([key]) => key === 'map' || /^map-?\d+$/.test(key))
        .sort(([a], [b]) => a.localeCompare(b, undefined, { numeric: true }));
      for (const [, value] of mapParts) Object.assign(messages, JSON.parse(value || '{}'));
    } catch (error) {
      console.error('[AP i18n] Invalid translation map', error);
      return;
    }

    const templates = Object.entries(messages)
      .filter(([key]) => /__[A-Z0-9_]+__/.test(key))
      .map(([key, value]) => {
        const names = [];
        const pattern = escapeRegExp(key).replace(/__([A-Z0-9_]+)__/g, (_, name) => {
          names.push(name);
          return '(.+?)';
        });
        return { regex: new RegExp(`^${pattern}$`), names, value };
      });

    const translate = (value) => {
      const normalized = value.replace(/\s+/g, ' ').trim();
      if (!normalized) return value;
      let translated = messages[normalized];
      if (!translated) {
        for (const template of templates) {
          const match = normalized.match(template.regex);
          if (!match) continue;
          translated = template.value;
          template.names.forEach((name, index) => {
            translated = translated.replace(`__${name}__`, match[index + 1]);
          });
          break;
        }
      }
      if (!translated || translated === normalized) return value;
      return value.replace(normalized, translated);
    };

    const translateElement = (element) => {
      if (!(element instanceof Element)) return;
      for (const attribute of ['aria-label', 'placeholder', 'title']) {
        if (element.hasAttribute(attribute)) {
          element.setAttribute(attribute, translate(element.getAttribute(attribute)));
        }
      }

      const root = config.dataset.root || '';
      if (root && root !== '/' && element instanceof HTMLAnchorElement) {
        const href = element.getAttribute('href') || '';
        if (/^\/(products|collections|pages|blogs)\//.test(href) && !href.startsWith(`${root}/`)) {
          element.setAttribute('href', `${root}${href}`);
        }
      }
    };

    const apply = (node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        const parent = node.parentElement;
        if (!parent || /^(SCRIPT|STYLE|NOSCRIPT)$/.test(parent.tagName)) return;
        const translated = translate(node.nodeValue);
        if (translated !== node.nodeValue) node.nodeValue = translated;
        return;
      }
      if (!(node instanceof Element)) return;
      translateElement(node);
      const walker = document.createTreeWalker(node, NodeFilter.SHOW_TEXT);
      let textNode;
      while ((textNode = walker.nextNode())) apply(textNode);
      node.querySelectorAll('*').forEach(translateElement);
    };

    apply(scope);
    new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'characterData') apply(mutation.target);
        mutation.addedNodes.forEach(apply);
      }
    }).observe(scope, { childList: true, subtree: true, characterData: true });
  };

  const start = () => document.querySelectorAll('[data-ap-runtime-i18n]').forEach(boot);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
